import { useNavigate, useParams } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import OrderConfirmationModal from './components/OrderConfirmationModal';
import useOrderConfirmation from 'src/api/temp/famous/useOrderConfirmation';
import { orpc } from 'src/api/rpc/client';
import { Card, CircularProgress } from '@mui/material';
import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import ErrorMessage from 'src/components/errorMessage/ErrorMessage';

export function Route() {
  const { orderConfirmationId } = useParams({
    from: '/authenticated/famous-edi-order-confirmation/$orderConfirmationId',
  });
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const {
    data: orderConfirmation,
    isLoading,
    isFetching,
    error,
  } = useOrderConfirmation(orderConfirmationId);

  const handleClose = (_shouldRefetch?: boolean) => {
    // Refresh the table rows as the modal closes so any status change
    // while the modal was open is reflected in the background list.
    queryClient.invalidateQueries({
      queryKey: orpc.edi.orderConfirmations.list.key(),
    });
    navigate({
      to: '..',
      viewTransition: true,
    });
  };

  if (isLoading) {
    return (
      <Card sx={{ p: 2, m: 2 }}>
        <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
          <CircularProgress size={24} sx={{ mr: 2 }} />
          <MDTypography variant="body2">
            Loading order confirmation...
          </MDTypography>
        </MDBox>
      </Card>
    );
  }

  if (error) {
    return (
      <Card sx={{ p: 2, m: 2 }}>
        <ErrorMessage error={error} />
      </Card>
    );
  }

  if (!orderConfirmation) {
    return null;
  }

  return (
    <OrderConfirmationModal
      orderConfirmation={orderConfirmation}
      onClose={handleClose}
      isFetching={isFetching}
    />
  );
}
